import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoadDetailContainerComponent } from '../shared/components';
import { ChatViewContainerComponent } from './components';
import { AuthGuard } from '../core/guards/auth.guard';

const routes: Routes = [
  {
    path: 'chat',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ChatViewContainerComponent,
      },
      {
        path: ':conversationId',
        component: ChatViewContainerComponent,
        children: [
          {
            path: 'load-details/:id',
            component: LoadDetailContainerComponent,
            data: { sidebar: true, modal: false },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChatRoutingModule {}
